import { Component, ViewChild } from '@angular/core';
import { VendorService } from '../../../services/vendorservice';
import { Router } from '@angular/router';
import { VendorDropdownData } from '../../DTO/vendor';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vendor-search',
  templateUrl: './vendor-search.component.html',
  styleUrls: ['./vendor-search.component.css']
})
export class VendorSearchComponent {

    displayedColumns: string[] = ['VendorId', 'VendorName', 'edit'];
    dataSource: any;
    isLoading: boolean = true;
    private vendorGridData?: VendorDropdownData;
    //private pharmacySearchModel?: PharmacySearchModel ={ PharmacyName :'',EffectiveDate:'',TermDate:'',PetEnabled:'', VendorId: 3};
    vendorFilter:string='';
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    applyFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }

    constructor(private vendorService: VendorService, private toastr:ToastrService, private router: Router) {}

    ngOnInit(): void {
      //this.vendorService.getVendors().subscribe();
      this.LoadData();
    }

    LoadData() {
      this.vendorService.getVendors().subscribe(res => {
        this.dataSource = new MatTableDataSource(VendorDropdownData.vendorList);
        this.isLoading = false;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filter = this.vendorFilter.trim().toLowerCase();
      },(error: any)=>{
        this.isLoading=false;
        this.toastr.error(error);
      });
    }

    public redirectToEdit = (id: string) => {
      this.router.navigate(['updatevendor/', id]);
    }

}
